function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FlagMetadata, LogLevel } from '@flagship.io/js-sdk';
import { noVisitorMessage } from './constants';
import { log } from './utils';
export var Flag = /*#__PURE__*/function () {
  function Flag(defaultValue) {
    _classCallCheck(this, Flag);

    _defineProperty(this, "_defaultValue", void 0);

    log(LogLevel.WARNING, noVisitorMessage, 'GetFlag');
    this._defaultValue = defaultValue;
  }

  _createClass(Flag, [{
    key: "getValue",
    value: function getValue() {
      log(LogLevel.WARNING, noVisitorMessage, 'getValue');
      return this._defaultValue;
    }
  }, {
    key: "exists",
    value: function exists() {
      log(LogLevel.WARNING, noVisitorMessage, 'exists');
      return false;
    }
  }, {
    key: "userExposed",
    value: function userExposed() {
      log(LogLevel.WARNING, noVisitorMessage, 'userExposed');
      return Promise.resolve();
    }
  }, {
    key: "metadata",
    get: function get() {
      log(LogLevel.WARNING, noVisitorMessage, 'metadata');
      return new FlagMetadata({
        campaignId: '',
        campaignType: '',
        isReference: false,
        variationGroupId: '',
        variationId: ''
      });
    }
  }]);

  return Flag;
}();